import { render, staticRenderFns } from "./MobileAns.vue?vue&type=template&id=55607acc"
import script from "./MobileAns.vue?vue&type=script&lang=ts"
export * from "./MobileAns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports